// extracted by mini-css-extract-plugin
export default {"centerHERE":"suspense_centerHERE__MjYHK","lds_roller":"suspense_lds_roller__fY8Ve","lds_spinner":"suspense_lds_spinner__M47jG"};